export default __webpack_public_path__ + "static/media/image_full_75.55e6d502.svg";